import { Outlet, matchPath, useLocation, useParams } from 'react-router-dom';

import { FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_SETUP } from '@sorare/core/src/constants/__generated__/routes';

import { PlayLayout } from 'components/rivals/PlayLayout';

const RivalMatchesLayout = () => {
  const { pathname } = useLocation();

  const { slug = '' } = useParams();
  const { date = '' } = useParams();

  const isSetup = !!matchPath(
    FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_SETUP,
    pathname
  );

  if (isSetup) {
    return <Outlet />;
  }

  if (!slug) {
    return null;
  }

  return (
    <PlayLayout slug={slug} date={date}>
      <Outlet />
    </PlayLayout>
  );
};
export default RivalMatchesLayout;
